/*!
 * Manera Sizechart
 * 
 */
$(document).ready(function()
{
    if ($('#sizecharts_nav .active').length == 0)
        $('#sizecharts_nav li').first().addClass('active');

    $('#sizecharts_nav li').on('click',function(e){

        $('#sizecharts_nav li').removeClass('active');
        $(this).addClass('active');

        if($(this).hasClass('first'))
        {
            $('.men').removeClass('d-none').addClass('d-block');
            $('.women').removeClass('d-block').addClass('d-none');
        }
        else if($(this).hasClass('last'))
        {
            $('.women').removeClass('d-none').addClass('d-block');
            $('.men').removeClass('d-block').addClass('d-none');
        }
    });


        var btn_fitting = $(".fitting_link").find(".inner");
        $(".fitting_link").find(".line1 .inner").prepend('<span class="w-line"></span>');


        TweenMax.to($(".fitting_link").find(".w-line"), .3, {
            width: 36,
            ease: Power2.easeOut,
            force3D: 1
        }, 0);


        $(".fitting_link").hover(function () {
            $(this).addClass('hover');
        }, function () {
            $(this).removeClass('hover');
        });
    //}
});